import { render, staticRenderFns } from "./onHefc.vue?vue&type=template&id=399fbc0b"
import script from "./onHefc.vue?vue&type=script&lang=js"
export * from "./onHefc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports